import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import ProductCard from '../components/ProductCard';
import { useData } from '../context/DataContext';
import { api } from '../lib/api';
import { ChevronRight } from 'lucide-react';

const SubCategoryPage = () => {
  const { slug } = useParams();
  const { tree, loading } = useData();
  const [products, setProducts] = useState([]);
  const [sortBy, setSortBy] = useState('relevance');

  // find sub-category
  let sub = null, cat = null, main = null;
  for (const m of tree) {
    for (const c of (m.categories || [])) {
      const f = (c.sub_categories || []).find((s) => s.slug === slug || s.id === slug);
      if (f) { sub = f; cat = c; main = m; break; }
    }
    if (sub) break;
  }

  useEffect(() => {
    if (!sub) return;
    api.getProducts({ sub_category_id: sub.id, sort: sortBy, limit: 60 })
      .then((d) => setProducts(d.items || [])).catch(() => {});
  }, [sub, sortBy]);

  if (loading) {
    return <div><Header /><div className="max-w-7xl mx-auto px-4 py-20 text-center text-gray-500">Loading...</div><Footer /></div>;
  }
  if (!sub) {
    return (
      <div>
        <Header />
        <div className="max-w-7xl mx-auto px-4 py-20 text-center">
          <h1 className="text-2xl font-bold">Sub-category not found</h1>
          <Link to="/" className="text-[#2c54b2] hover:underline mt-4 inline-block">Go back home</Link>
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />

      <div className="bg-white border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 py-3 flex items-center gap-1 text-xs text-gray-600 flex-wrap">
          <Link to="/" className="hover:text-[#2c54b2]">Home</Link>
          <ChevronRight className="w-3 h-3" />
          {main && <><Link to={`/main/${main.slug}`} className="hover:text-[#2c54b2]">{main.name}</Link><ChevronRight className="w-3 h-3" /></>}
          {cat && <><Link to={`/category/${cat.slug}`} className="hover:text-[#2c54b2]">{cat.name}</Link><ChevronRight className="w-3 h-3" /></>}
          <span className="text-gray-900 font-medium">{sub.name}</span>
        </div>
      </div>

      <section className="bg-gradient-to-r from-[#2c54b2] to-[#1e3a8a] text-white">
        <div className="max-w-7xl mx-auto px-4 py-8">
          <h1 className="text-3xl font-bold">{sub.name}</h1>
          <p className="text-blue-100 mt-1">{cat && (<>in <Link to={`/category/${cat.slug}`} className="underline hover:text-white">{cat.name}</Link></>)}</p>
        </div>
      </section>

      <div className="max-w-7xl mx-auto px-4 py-6">
        <div className="bg-white border border-gray-200 rounded-md px-4 py-3 mb-4 flex items-center justify-between">
          <div className="text-sm text-gray-700">{products.length} products in {sub.name}</div>
          <select value={sortBy} onChange={(e) => setSortBy(e.target.value)} className="text-sm border border-gray-300 rounded px-2 py-1 focus:outline-none focus:border-[#ee5e23]">
            <option value="relevance">Relevance</option>
            <option value="price-low">Price: Low to High</option>
            <option value="price-high">Price: High to Low</option>
          </select>
        </div>
        {products.length === 0 ? (
          <div className="bg-white border border-gray-200 rounded-md py-16 text-center">
            <p className="text-gray-600">No products yet in this sub-category.</p>
            {cat && <Link to={`/category/${cat.slug}`} className="text-[#2c54b2] hover:underline mt-2 inline-block">Browse {cat.name}</Link>}
          </div>
        ) : (
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
            {products.map((p) => <ProductCard key={p.id} product={p} />)}
          </div>
        )}
      </div>

      <Footer />
    </div>
  );
};

export default SubCategoryPage;
